module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_is-object.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_is-object.js
// module chunks = 168707334958949